import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Cart.css"; // Import the CSS file
import Footer from '../../Components/Footer/Footer';
import EmptyCart from '../../Images/CartImages/EmptyCart.png';
import Loading1 from "../../Components/Loading/Loading1";
import CustomNav from "../../Components/Navbar/NewNavbar";

const Cart = () => {
    const [cart, setCart] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const storedCart = localStorage.getItem("cart");
        if (storedCart) {
            setCart(JSON.parse(storedCart));
        }
    }, []);
    const Movetoservice = () => {
        navigate('/');
    }
    const removeFromCart = (index) => {
        let cartItems = [...cart];
        cartItems.splice(index, 1);
        updateCart(cartItems);
    };

    const incrementQty = (index) => {
        let cartItems = [...cart];
        cartItems[index].qty += 1;
        updateCart(cartItems);
    };

    const decrementQty = (index) => {
        let cartItems = [...cart];
        if (cartItems[index].qty > 1) {
            cartItems[index].qty -= 1;
        } else {
            cartItems.splice(index, 1);
        }
        updateCart(cartItems);
    };

    const updateCart = (cartItems) => {
        setCart(cartItems);
        localStorage.setItem("cart", JSON.stringify(cartItems));
    };

    const calculateTotal = () => {
        return cart.reduce((total, item) => total + item.discountedPrice, 0).toFixed(2);
    };

    const handleCheckout = () => {
        navigate('/checkout', { state: { cart } });
    };
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, []);
    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <CustomNav />
            <div className="cart-container my-5">
                {cart.length === 0 ? (
                    <div className="emptycart-maincontainer">
                        <div className="cart-empty">
                            <p style={{ fontSize: 20 }}>Your cart is empty</p>
                            <div className="emptycartimg">
                                <img src={EmptyCart} alt="Empty Cart" />
                            </div>
                            <button><Link to="/" className="btn btn-dark" style={{ textDecoration: 'none', color: 'white' }}>View Services</Link></button>
                        </div>
                    </div>
                ) : (
                    <div className="cart-items-container">
                        <div className="cart-item-container1">
                            {cart.map((item, index) => (
                                <div key={index} className="cart service-card">
                                    <div className="card-service-card-container">
                                        <img src={item.img} className="card-img-top" alt={item.name} />
                                        <div className="card-body">
                                            <h5 className="card-title">{item.name}</h5>
                                            <p className="card-text">{item.description}</p>
                                            <div className="removebtn">
                                                <button className="btn btn-add" onClick={() => removeFromCart(index)}>
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>
                        <div className="cart-summary">
                            <h2>Order Summary</h2>
                            <p>Services ({cart.length}) <span>Rs.{calculateTotal()}</span></p>
                            <h3>Total amount <span>Rs.{(parseFloat(calculateTotal())).toFixed(2)}</span></h3>
                            <div className="continueservice">
                                <button className="btn btn-dark" onClick={handleCheckout}>Go to checkout</button>
                                <button className="btn btn-dark" onClick={Movetoservice}>View Services</button>
                            </div>
                        </div>

                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default Cart;
